/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.14.0
 */

import { FC, Fragment, ReactNode } from 'react';

import { TooltipModalBodyStyled } from './styled/TooltipModalStyled';
import { useTooltipModalContext } from './TooltipModalContext';

export interface ITooltipModalComposition {
    Body: FC<IModalCompoundBody>;
}

export interface IModalCompoundBody {
    children: ReactNode;
}

export const ModalCompoundBody = ({ children }: IModalCompoundBody) => {

    const { isTooltipShown } = useTooltipModalContext();

    return <Fragment>
        {isTooltipShown && (<TooltipModalBodyStyled>
            {children}
        </TooltipModalBodyStyled>)}
    </Fragment>;
};
